const e = Object.freeze({
  DEV: "https://storage.googleapis.com/devtest-petcircle-assets",
  PROD: "https://www.petcircle.com.au/petcircle-assets"
});
export {
  e as PET_CIRCLE_ASSETS
};
